<template>
  <div id="footer" class="bg-col17 point">
    <div class="footcon flex">
      <div class="model1 mt-50">
        <div class="fs-18 color-colB5">关于我们</div>
        <div class="line mt-20"></div>
        <div class="list mt-50 fs-14 color-colB5">
          <li class="flex ai-center">
            <div class="disc mr-10"></div>
            主管单位：中华人民共和国商务部
          </li>
          <li class="mt-10 pl-85">国际贸易经济合作研究院</li>
        </div>
      </div>
      <div class="model1 mt-50 ml-40">
        <div class="fs-18 color-colB5">友情链接</div>
        <div class="line mt-20"></div>
        <div class="list mt-50 fs-14 color-colB5">
          <a
            :target="item.link ? '_blank' : '_self'"
            class="flex color-colB5 ai-center mb-10"
            v-for="(item, index) in linklist"
            :key="index"
            :href="item.link ? item.link : 'javascript:void(0);'"
          >
            <div class="disc mr-10"></div>
            {{ item.title }}
          </a>
          <!-- <a
            href="http://www.caitec.org.cn/"
            target="_blank"
            class="color-colB5 flex ai-center mt-30"
          >
            <div class="disc mr-10"></div>
            国际贸易经济合作研究院
          </a>
          <span class="color-colB5 flex ai-center mt-30">
            <div class="disc mr-10"></div>
            中国国际贸易学会
          </span>
          <a
            href="http://www.suibe.edu.cn/"
            target="_blank"
            class="color-colB5 flex ai-center mt-30"
          >
            <div class="disc mr-10"></div>
            上海对外贸易大学
          </a>
          <a
            href=" http://www.uibe.edu.cn/"
            target="_blank"
            class="color-colB5 flex ai-center mt-30"
          >
            <div class="disc mr-10"></div>
            对外经济贸易大学
          </a> -->
        </div>
      </div>
      <div class="model1 model2 mt-50 ml-40">
        <div class="fs-18 color-colB5">服务支持</div>
        <div class="line mt-20"></div>
        <div class="list mt-50 fs-14 color-colB5">
          <li class="flex ai-center" @click="download()">
            <div class="disc mr-10"></div>
            书目下载
          </li>
          <li class="flex ai-center mt-10" @click="bookrequest()">
            <div class="disc mr-10"></div>
            课件索取
          </li>
          <a
            href="https://shop162373850.taobao.com/"
            target="_blank"
            class="color-colB5 flex ai-center mt-10"
          >
            <div class="disc mr-10"></div>
            淘宝网店
          </a>
          <li @click="tous" class="color-colB5 flex ai-center mt-10">
            <div class="disc mr-10"></div>
            联系我们
          </li>
        </div>
      </div>
      <div class="model5 mt-50 ml-40 flex jc-center flex-w">
        <img src="../../assets/image/qr1.jpg" alt="" />
        <div class="fs-14 color-colB5 mt-10">中国商务出版社微信公众号</div>
        <!-- <img src="../../assets/image/qr2.png" class="mt-50" alt="" />
        <div class="fs-14 color-colB5 mt-10">中商智库微信号</div> -->
      </div>
      <div class="model5 mt-50 ml-30 flex jc-center flex-w">
        <img src="../../assets/image/dou.png" alt="" />
        <div class="fs-14 color-colB5 mt-10">中国商务出版社有限公司</div>
        <div class="fs-12 color-colB5">图书杂志出版-数字出版-智库传媒</div>
      </div>
    </div>
    <div
      class="bootom text-center fs-14 color-colB5 bg-black"
      style="display: flex; justify-content: center; align-items: center"
    >
      Copyright 2021中国商务出版社有限公司 版权所有
      <a style="color: #B5B5B5;" href="https://beian.miit.gov.cn" target="_blank"
        >京ICP备05052274号51La</a
      >
      <a
        style="display: flex; justify-content: center; align-items: center;margin-left:10px;"
        target="_blank"
        href="https://beian.miit.gov.cn"
      >
        <img
          style="width: 20px; height: 20px;margin-right:10px;"
          src="../../assets/image/wang.png"
          alt=""
        />
        <p style="color:#939393;">京公网安备 11010102004514号</p>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Foot",
  props: {},
  data() {
    return {
      linklist: [],
    };
  },
  computed: {},
  mounted() {
    this.getlist();
  },
  methods: {
    //查询侧边导航
    async getlist() {
      var res = await this.$API.API_Ajax("期刊列表", {
        columnId: 129,
      });
      if (res.code == 200) {
        this.linklist = res.data;
      }
    },
    //联系我们
    tous() {
      this.$router.push({ path: "/contentus" });
    },
    //书目下载
    download() {
      this.$router.push({ path: "/bookdownload" });
    },
    //课件检索
    bookrequest() {
      this.$router.push({ path: "/bookrequest" });
    },
  },
};
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  height: 570px;
  margin-top: -10px;
  z-index: 99;
  .footcon {
    width: 65%;
    margin: auto;
    .model1 {
      width: 330px;
      height: 430px;
      .line {
        width: 97px;
        height: 2px;
        background: #3c3b3b;
      }
      .list {
        width: 100%;
        .disc {
          width: 3px;
          height: 3px;
          background-color: #3b8ce0;
          border-radius: 50%;
        }
      }
    }
    .model2 {
      width: 120px;
      height: 430px;
    }
    .model3 {
      width: 180px;
      height: 400px;
      img {
        width: 132px;
        height: 125px;
      }
    }
    .model4 {
      width: 270px;
      height: 230px;
      img {
        width: 164px;
        height: 165px;
      }
    }
    .model5 {
      width: 290px;
      height: 230px;
      img {
        width: 164px;
        height: 165px;
      }
    }
  }
  .bootom {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }
}
</style>
